import React, { useState } from 'react';
import {
  Banner,
  Gutter,
  IconButton,
  Layout,
  LayoutItem,
  LocalStorage,
} from '@axiom/ui';
import type { Experience } from '@axiom/validation';

export type ExperiencesShortBannerType = {
  experienceId: Experience['id'];
};

export const ExperiencesShortBanner = ({
  experienceId,
}: ExperiencesShortBannerType) => {
  const localStorage = LocalStorage(
    `dismissed-banner-short-axiom-experience-${experienceId}`,
    false
  );
  const [dismissedBanner, setDismissedBanner] = useState(localStorage.get());

  const handleOnClick = () => {
    localStorage.set(!dismissedBanner);
    setDismissedBanner(!dismissedBanner);
  };

  return dismissedBanner ? null : (
    <Gutter bottom="16px">
      <Banner name="SHORT_EXPERIENCE" type="info">
        <Layout>
          <LayoutItem>
            If this Axiom Experience ended earlier than anticipated, your Talent
            Success Partner can assist with removing it from your profile if
            desired.
          </LayoutItem>

          <LayoutItem>
            <IconButton
              icon="x-mark"
              name="SHORT_EXPERIENCE_DISMISS"
              onClick={() => {
                handleOnClick();
              }}
              pattern="secondary"
              variation="minimal"
            />
          </LayoutItem>
        </Layout>
      </Banner>
    </Gutter>
  );
};
